import * as React from 'react'

/**
 * @description EmailOpen icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { EmailOpen } from '@sravni/design-system-icons'
 *
 * <EmailOpen />
 * ```
 */
export const EmailOpen = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="EmailOpen" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.5 8.086v7.747c0 .921.746 1.667 1.667 1.667h11.665c.921 0 1.667-.746 1.667-1.667V8.086M7.6 12.4l-4.608 4.608M17.008 17.008 12.4 12.4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5.518 3.238 6.703a1.667 1.667 0 0 0 0 2.766l4.895 3.293c1.129.76 2.604.76 3.732 0L16.76 9.47a1.667 1.667 0 0 0 0-2.766L15 5.518"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 10.654V3.252a.834.834 0 0 0-.833-.834H5.833A.834.834 0 0 0 5 3.252v7.402M7.5 5.417h5M7.5 8.333h5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
